import { Button } from '@/components/ui/button'
import { useState } from 'react'
import type { AnswerInputProps } from '../QuestionRenderer'

export function DateInput({ value, onChange, onSubmit }: AnswerInputProps<string>) {
  const [current, setCurrent] = useState(() => new Date())
  const firstDay = new Date(current.getFullYear(), current.getMonth(), 1).getDay()
  const days = new Date(current.getFullYear(), current.getMonth() + 1, 0).getDate()
  const emptySlots = ['empty-sun', 'empty-mon', 'empty-tue', 'empty-wed', 'empty-thu', 'empty-fri']

  function choose(day: number) {
    const next = new Date(current.getFullYear(), current.getMonth(), day).toISOString().slice(0, 10)
    onChange(next)
    onSubmit()
  }

  return (
    <div className="max-w-md rounded-lg border border-slate-200 bg-white p-4">
      <div className="mb-4 flex items-center justify-between">
        <Button
          variant="outline"
          size="sm"
          onClick={() => setCurrent(new Date(current.getFullYear(), current.getMonth() - 1, 1))}
        >
          上月
        </Button>
        <div className="font-semibold">
          {current.getFullYear()} / {current.getMonth() + 1}
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setCurrent(new Date(current.getFullYear(), current.getMonth() + 1, 1))}
        >
          下月
        </Button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center text-xs text-slate-500">
        {['日', '一', '二', '三', '四', '五', '六'].map((day) => (
          <div key={day}>{day}</div>
        ))}
      </div>
      <div className="mt-2 grid grid-cols-7 gap-1">
        {emptySlots.slice(0, firstDay).map((slot) => (
          <div key={slot} />
        ))}
        {Array.from({ length: days }, (_, index) => index + 1).map((day) => {
          const iso = new Date(current.getFullYear(), current.getMonth(), day)
            .toISOString()
            .slice(0, 10)
          return (
            <button
              key={day}
              type="button"
              onClick={() => choose(day)}
              className={`grid min-h-10 place-items-center rounded-md text-sm hover:bg-indigo-50 ${
                value === iso ? 'bg-indigo-600 text-white' : 'bg-white'
              }`}
            >
              {day}
            </button>
          )
        })}
      </div>
    </div>
  )
}
